import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { Header } from 'antd/es/layout/layout';
import { styled } from 'styled-components';
import { themecolor } from '../config.js';
import HeaderFilters from './HeaderFilters';

const StyleHeader = styled(Header)`
  padding-inline: 24px;
  position: fixed;
  left: ${({ theme }) => theme.direction === 'rtl' ? '0' : `${themecolor.components.Menu.verticalSidebarWidth}px`};
  right: ${({ theme }) => (theme.direction === 'rtl' ? `${themecolor.components.Menu.verticalSidebarWidth}px` : '0')};
  top: 0;
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.token.colorBorder};
  z-index: 999;
  background: ${({ theme }) => theme.token.colorBgContainer};

  @media screen and (max-width: 768px) {
    /* Apply the responsive style without considering RTL or LTR */
    left: 0;
    right: 0;
  }
`;

const HeaderLayout = () => {

    const [isClick, setIsClick] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);


    useEffect(() => {
        setIsClick(false);
        updateWindowDimensions(); // Initialize windowWidth state
        window.addEventListener('resize', updateWindowDimensions);

        return () => {
            window.removeEventListener('resize', updateWindowDimensions);
        };
    }, []);

    const updateWindowDimensions = () => {
        setWindowWidth(window.innerWidth);
    };

    // Set the visibility of the sidebar based on window width
    useEffect(() => {
        const sidebarLayout = document.getElementById('sidebar-layout');
        if (sidebarLayout) {
            if (windowWidth < 768) {
                sidebarLayout.style.display = 'none';

            } else {
                sidebarLayout.style.display = 'block';
            }
        }
    }, [windowWidth]);

    return (
        <React.Fragment>
            <StyleHeader id="antHeaderMain" style={{'height': '100px'}}>
                <Row align="stretch" gutter={[16, 24]} style={{ height: '100%' }}>
                    <Col span={24}>
                        <HeaderFilters />
                    </Col>
                </Row>
            </StyleHeader>
        </React.Fragment>
    );
};

export default HeaderLayout;
